import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './userList.scss';
import {
  NormalSearchIcon,
  PlusIcon,
  TrashIconFillIcon,
  CloseIcon,
} from '../../icons/icons';
import ReactCheckbox from '../../custom-checkbox/react-check-box';
import ListingStatus from '../../listing-status/listing-status';
import IconButton from '../../icon-button/icon-button';
import { getUser } from '../../../service/authService';

export default function ListOfUser({
  users,
  addUserInChannel,
  removeUserFromChannel,
  allowAddUser,
  allowRemoveUser,
  selectedUsers,
  setSelectedUsers,
  disableSearch,
}) {
  const [t] = useTranslation('manageorders');
  const [userList, setUserList] = useState(users);
  const [searchValue, setSearchValue] = useState('');
  const [originalUserList, setOriginalUserList] = useState([]);
  const userData = getUser();
  const popupRef = useRef(null);

  const handleFilter = (query, data) => {
    setSearchValue(query);
    if (query?.length > 0) {
      const filtered = data?.filter((user) => {
        return (
          `${user.firstName}${user.lastName}`
            ?.toLowerCase()
            ?.includes(query?.toLowerCase()?.replace(/\s+/g, '')) ||
          user?.email?.toLowerCase()?.includes(query?.toLowerCase())
        );
      });
      setUserList(filtered);
    } else {
      setUserList(data);
    }
  };

  useEffect(() => {
    if (searchValue) handleFilter(searchValue, users);
    else setUserList(users);
    setOriginalUserList(users);
  }, [users]);

  const handleClearSearch = () => {
    setSearchValue('');
    setUserList(originalUserList);
  };

  const handleInitialUserName = (str) => {
    let name = str
      ?.split(' ')
      ?.map((word) => word?.[0])
      ?.join('');
    name = name?.substr(0, 1);
    return name?.toUpperCase() || '';
  };

  const handleColorCodeIns = (str) => {
    let name = str
      ?.split(' ')
      ?.map((word) => word[0])
      ?.join('');
    name = name?.substr(0, 1);
    return name?.toLowerCase() || '';
  };

  const handleUserSelection = (e) => {
    if (e?.target?.checked) {
      setSelectedUsers((prev) => [...new Set([...prev, e?.target?.value])]);
    } else {
      setSelectedUsers((prev) => prev?.filter((id) => id !== e?.target?.value));
    }
  };
  useEffect(() => {
    if (!disableSearch) {
      popupRef.current.focus();
    }
  }, []);
  return (
    <div className={`chat-user-list-container ${disableSearch ? 'pt-0' : ''}`}>
      {!disableSearch && (
        <div className="user-search-box">
          <input
            type="text"
            placeholder={t('manageordersscreen.chatmenu.search')}
            onChange={(e) => handleFilter(e?.target?.value, originalUserList)}
            value={searchValue}
            ref={popupRef}
          />
          <NormalSearchIcon size="1.181vw" />

          {searchValue && (
            <button
              type="button"
              className="clear-usersearch"
              onClick={handleClearSearch}
            >
              <span>
                <CloseIcon size="1.111vw" color="#C2C0C0" />
              </span>
            </button>
          )}
        </div>
      )}

      <ul className="chat-user-list">
        {userList.length > 0 ? (
          users &&
          userList.map((val) => (
            <li className="hover-pointer" key={val?.id || val?.userSub}>
              {/* enable for adding bulk participants */}
              {false && (
                <ReactCheckbox
                  className="w-100"
                  checked={selectedUsers?.includes(val?.userSub)}
                  name={val?.firstName}
                  value={val?.userSub}
                  onChange={handleUserSelection}
                />
              )}

              {/* Send below code block as children in the ReactCheckbox for adding bulk participants */}
              <div className="d-flex w-100">
                <div
                  className={`user-image border-white ${handleColorCodeIns(
                    val?.firstName
                  )}`}
                >
                  {val?.profilePicture !== '' ? (
                    <img src={val?.profilePicture} alt="user" />
                  ) : (
                    <span>
                      {handleInitialUserName(val?.firstName)}
                      {handleInitialUserName(val?.lastName)}
                    </span>
                  )}
                </div>
                <div className="user-details">
                  <h4>
                    {val?.firstName} {val?.lastName}
                  </h4>
                  <p>{val.email}</p>
                </div>
              </div>

              <ListingStatus statusLabel={val?.userType} className="d-flex" />

              {/* comment below block for adding bulk participants */}
              {allowAddUser && (
                <IconButton
                  size="small"
                  verient="primary"
                  onClick={() => addUserInChannel(val?.userSub)}
                  className="ml-10"
                >
                  <PlusIcon color="#1d3e69" />
                </IconButton>
                // <button
                //   type="button"
                //   className="invite-btn-chat"
                //   onClick={() => addUserInChannel(val?.userSub)}
                // >
                //   <PlusIcon color="#1d3e69" />
                // </button>
              )}
              {allowRemoveUser &&
                val?.userSub !== userData.sub &&
                val?.userType !== '_keyAdmin' && (
                  <IconButton
                    size="small"
                    verient="delete"
                    onClick={() => removeUserFromChannel(val?.userSub)}
                    className="ml-10"
                  >
                    <TrashIconFillIcon color="#ffffff" />
                  </IconButton>
                )}
            </li>
          ))
        ) : (
          <li className="no-data">
            {t(
              'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.noSearchResultAvailable'
            )}
          </li>
        )}
      </ul>
    </div>
  );
}

ListOfUser.propTypes = {
  users: PropTypes.objectOf(Array),
  addUserInChannel: PropTypes.func,
  removeUserFromChannel: PropTypes.func,
  allowAddUser: PropTypes.bool,
  allowRemoveUser: PropTypes.bool,
  selectedUsers: PropTypes.instanceOf(Array),
  setSelectedUsers: PropTypes.func,
  disableSearch: PropTypes.bool,
};
ListOfUser.defaultProps = {
  users: [],
  addUserInChannel: () => {},
  removeUserFromChannel: () => {},
  allowAddUser: false,
  allowRemoveUser: false,
  selectedUsers: [],
  setSelectedUsers: () => {},
  disableSearch: false,
};
